"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayingResolver__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IEAS",
                name: "eas",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "incentive",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AccessDenied",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidEAS",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidValue",
        type: "error",
    },
    {
        inputs: [],
        name: "NotPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        name: "attest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "isPayable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation[]",
                name: "attestations",
                type: "tuple[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
        ],
        name: "multiAttest",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation[]",
                name: "attestations",
                type: "tuple[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
        ],
        name: "multiRevoke",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "uid",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "time",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expirationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "revocationTime",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "refUID",
                        type: "bytes32",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "revocable",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct Attestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        name: "revoke",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class PayingResolver__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(eas, incentive, overrides) {
        return super.deploy(eas, incentive, overrides || {});
    }
    getDeployTransaction(eas, incentive, overrides) {
        return super.getDeployTransaction(eas, incentive, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PayingResolver__factory = PayingResolver__factory;
//# sourceMappingURL=PayingResolver__factory.js.map